import Bbc from "../images/brands/bbc-black";
import Distell from "../images/brands/distell-black";
import Engen from "../images/brands/engen-black";
import Liquid from "../images/brands/liquid";
import Microsoft from "../images/brands/microsoft-black";
import Multichoice from "../images/brands/multichoice-black";
import Nike from "../images/brands/nike-black";
import Pnp from "../images/brands/pnp-black";
import Sanlam from "../images/brands/sanlam-black";
import Santam from "../images/brands/santam-black";
import Spotify from "../images/brands/spotify-black";
import Tfg from "../images/brands/tfg-black";
import TymeBank from "../images/brands/tyme-bank-black";
import Visa from "../images/brands/visa-black";
import Wesgrow from "../images/brands/wesgrow-black";
import {
  Box
} from "@chakra-ui/react";

const imageMapper = {
  "visa": Visa(),
  "tyme": TymeBank(),
  "distell": Distell(),
  "spotify": Spotify(),
  "microsoft": Microsoft(),
  "engen": Engen(),
  "nike": Nike(),
  "wesgrow": Wesgrow(),
  "multichoice": Multichoice(),
  "pnp": Pnp(),
  "liquid": Liquid(),
  "tfg": Tfg(),
  "sanlam": Sanlam(),
  "santam": Santam(),
  "bbc": Bbc(),
}

function SvgLogo(props) {
  return (
    <Box width="100px" m="2" display="flex" className="logo">
      {imageMapper[props.altText]}
    </Box>
  );
}

export default SvgLogo;
